import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { AdminSidebar } from "@/components/admin/AdminSidebar";
import { Overview } from "@/components/admin/Overview";
import { ContentEditor } from "@/components/admin/ContentEditor";
import { ServicesManager } from "@/components/admin/ServicesManager";
import { BooksManager } from "@/components/admin/BooksManager";
import { ReservationsManager } from "@/components/admin/ReservationsManager";
import { MembersManager } from "@/components/admin/MembersManager";
import { YoutubeManager } from "@/components/admin/YoutubeManager";

const views = {
  overview: Overview,
  content: ContentEditor,
  services: ServicesManager,
  books: BooksManager,
  reservations: ReservationsManager,
  members: MembersManager,
  youtube: YoutubeManager,
};

export default function AdminDashboard() {
  const [active, setActive] = useState("overview");
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const View = views[active];

  const doLogout = () => { logout(); navigate("/"); };

  return (
    <div className="flex flex-col lg:flex-row min-h-screen bg-[#08080A] text-slate-100" data-testid="admin-dashboard">
      <AdminSidebar active={active} setActive={setActive} onLogout={doLogout} />
      <div className="flex-1 flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-amber-500/10">
          <span className="text-sm text-slate-400">Connecté : <span className="text-amber-200">{user?.email}</span></span>
          <button onClick={doLogout} className="lg:hidden inline-flex items-center gap-2 text-red-300 text-sm"><LogOut size={16} /> Sortir</button>
        </div>
        <div className="p-6 lg:p-10 flex-1">
          <View />
        </div>
      </div>
    </div>
  );
}
